import React from 'react';
import { IonProgressBar } from '@ionic/react';
import Info from '../info/info.component';
import { StyledProcessingBanner, StyledProcessingRefresh } from './processingBanner.style';

type ProcessingBannerProps = {
    count: number;
    bannerText: string;
    refreshText: string;
    showFinished: boolean;
    onRefresh: () => void;
};

const ProcessingBanner: React.FC<ProcessingBannerProps> = ({ count, bannerText, refreshText, showFinished, onRefresh }) => {
    if (count > 0) {
        return (
            <Info className="centered">
                <StyledProcessingBanner>
                    <span className="label">{bannerText}</span>
                    <IonProgressBar type="indeterminate" color="primary" />
                </StyledProcessingBanner>
            </Info>
        );
    }

    if (showFinished) {
        return (
            <Info className="centered">
                <StyledProcessingRefresh onClick={onRefresh}>
                    {refreshText}
                </StyledProcessingRefresh>
            </Info>
        );
    }

    return null;
};

export default ProcessingBanner;
